var render = function () {
var _obj, _obj$1, _obj$2, _obj$3, _obj$4;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    absolute: true,
    'z-10': true,
    'top-0 right-0': true,
    group: true,
    'rounded-tr-xl': true,
  }},[_c('div',{staticClass:"transform"},[_c('div',{class:{
        'h-[29px] w-min': true,
        relative: true,
        flex: true,
        'pl-1': true,
        'overflow-hidden': !_vm.isTouchable,
        'overflow-visible': _vm.isTouchable,
      }},[(_vm.xEditPost)?_c('div',{class:( _obj = {
          'transition-all': true,
          'translate-x-full group-hover:translate-x-0': true,
          'rounded-bl-lg': true,
          'pr-[9px]': true,
          'mt-[3px] mr-[-8px]': true,
          'transform translate-x-full group-hover:translate-x-0': true,
          'flex justify-start items-start': true
        }, _obj[_vm.colorClasses[0]] = _vm.colorScheme === 'light', _obj[_vm.colorClasses[1]] = _vm.colorScheme === 'dark', _obj )},[(_vm.xOverlay)?_c('div',{class:( _obj$1 = {
            absolute: true,
            'left-[-4px] top-[4px]': !_vm.isStream,
            'left-[-4px] top-[8px]': _vm.isStream
          }, _obj$1[_vm.colorClasses[2]] = _vm.colorScheme === 'light', _obj$1[_vm.colorClasses[3]] = _vm.colorScheme === 'dark', _obj$1 )}):_vm._e(),_vm._v(" "),_c('oz-button',{class:{
            'h-4 mt-[5px] mb-[5px]': true,
            'font-semibold': true,
            'hover-hover:hover:font-semibold': true,
            'bg-transparent': true,
            'text-dark-text-200': _vm.colorScheme === 'light',
            'text-light-text-200': _vm.colorScheme === 'dark',
            'hover-hover:hover:text-dark-text-100': _vm.colorScheme === 'light',
            'hover-hover:hover:text-light-text-100': _vm.colorScheme === 'dark',
            'hover-hover:focus:text-grape-500': _vm.colorScheme === 'light',
            'hover-hover:focus:text-canary-500': _vm.colorScheme === 'dark',
            'hover-hover:active:text-grape-500': _vm.colorScheme === 'light',
            'hover-hover:active:text-canary-500': _vm.colorScheme === 'dark',
          },attrs:{"type":"custom","color-scheme":"secondary","dark-theme-type":"custom","is-dark":_vm.colorScheme === 'dark',"font-size":12,"should-fix-height":false,"x-text-padding":false},on:{"click":function($event){return _vm.$emit('edit')}}},[_vm._v(_vm._s(_vm._f("__")('Edit')))])],1):_vm._e(),_vm._v(" "),(_vm.xEditPost)?_c('div',{class:{
          'z-20': true,
          'opacity-0 group-hover:opacity-100': true,
          'transition-opacity': true,
          'h-4 mt-[8px] mb-[5px]': true,
          'w-[0px]': true,
          'border-r-[0.5px] border-solid': true,
          'border-dark-text-400': _vm.colorScheme === 'light',
          'border-light-text-400': _vm.colorScheme === 'dark',
        }}):_vm._e(),_vm._v(" "),_c('div',{class:( _obj$2 = {
          'w-5.5 mt-[3px] h-[26px]': true,
          'z-10': true,
          flex: true,
          relative: true,
          'overflow-visible': true,
          'justify-end': true,
          'rounded-bl-lg': true
        }, _obj$2[_vm.colorClasses[0]] = _vm.colorScheme === 'light', _obj$2[_vm.colorClasses[1]] = _vm.colorScheme === 'dark', _obj$2 )},[(_vm.xOverlay)?_c('div',{class:[
            ( _obj$3 = {
              absolute: true,
              'left-[-4px] top-[4px]': !_vm.isStream,
              'left-[-4px] top-[8px]': _vm.isStream
            }, _obj$3[_vm.colorClasses[2]] = _vm.colorScheme === 'light', _obj$3[_vm.colorClasses[3]] = _vm.colorScheme === 'dark', _obj$3['transition opacity-100 group-hover:opacity-0'] =  _vm.xEditPost, _obj$3 ) ]}):_vm._e(),_vm._v(" "),_c('oz-button',{class:{
            'post-actions-button': true,
            'flex-shrink-0': true,
            'px-[3px]': true,
            'w-[48px] h-[48px] pl-[26px] pb-[22px]': _vm.isTouchable,
            'w-5.5 h-[26px]': !_vm.isTouchable,
            'p-0': true,
            'text-dark-text-200': _vm.colorScheme === 'light',
            'text-light-text-200': _vm.colorScheme === 'dark',
            'hover-hover:hover:text-grape-500': _vm.colorScheme === 'light',
            'hover-hover:hover:text-canary-500': _vm.colorScheme === 'dark',
          },attrs:{"type":"text","icon-name":"more_vertical","color-scheme":"secondary","icon-size":16,"dark-theme-type":"custom","is-dark":_vm.colorScheme === 'dark',"should-fix-width":false,"should-fix-height":false},on:{"click":function($event){return _vm.$emit('dropdown')}}})],1)]),_vm._v(" "),(_vm.xOverlay)?_c('div',{class:[
        ( _obj$4 = {
          absolute: true,
          'bottom-[-4px] right-[7px]': !_vm.isStream,
          'bottom-[-4px] right-[11px]': _vm.isStream
        }, _obj$4[_vm.colorClasses[2]] = _vm.colorScheme === 'light', _obj$4[_vm.colorClasses[3]] = _vm.colorScheme === 'dark', _obj$4 ) ]}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }